import {Link,useNavigate } from "react-router-dom"
import { useEffect, useState } from "react";
import logo from "../assets/images/logo.png"
import "../commonlayouts/employerlayout.css"
import FooterLayout from "./beforeloginfooter";

const SuperAdminLayout = ({children}) => {
  const [isOpen, setIsopen] = useState(false);
    const ToggleSidebar = () => {
        isOpen === true ? setIsopen(false) : setIsopen(true);
    }
    return ( 
      <>
      <div className="container-fluid mt-3">
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-md">
                  <div className="container-fluid p-2">
                  <div className="btn btn-primary" onClick={ToggleSidebar} >
                              <i className="fa fa-bars"></i>
                          </div>
                      
                      <div className="form-inline ml-auto">
                      <img src={logo}  height={50} />  
                      </div>
                  </div>
              </nav>
              <div className={`sidebar ${isOpen == true ? 'active' : ''}`}>
                  <div className="sd-header">
                  <img src={logo} height={60}/>
                      <div className="btn btn-primary" onClick={ToggleSidebar}><i className="fa fa-times"></i></div>
                  </div>
                  <div className="sd-body">
                            <ul>
                            <li><Link to="/Admin/Dashboard"  className="sd-link">Dashboard</Link></li>
                            <li><Link to="/Admin/ListofallClients"  className="sd-link">Clients</Link></li>
                            
                            <li><Link to="/home"  className="sd-link">Logout</Link></li>
                                

                            </ul>
                        </div>
              </div>
              <div className={`sidebar-overlay ${isOpen == true ? 'active' : ''}`} onClick={ToggleSidebar}></div>
              <div className="container">
           {children}
        </div>
     
     </div>
     <div className="" style={{marginTop:400}}>
        <FooterLayout/>
        </div>
    
  </>
     );
}
 
export default SuperAdminLayout;